import { hexToRgbA, getLightenColor, getDarkenColor } from "./"

export default (type, colors) => {
  const styles = {
    default: {
      "search-results": {
        customCSS: `
          .search-display-tools>.panel__tool,
          .search-display-tools>.select {
            float: right;
          }
        `
      },
      "c-results__dropdown-wrapper": {
        float: "left"
      }
      // 'search-results__listings': {
      //   background: 'transparent'
      // },
      // 'c-results-filters': {
      //   background: getLightenColor(colors.primary, 2),
      // },
      // 'c-results-panel': {
      //   background: getLightenColor(colors.primary, 2),
      // },
      // 'search-results__panel-search-tool': {
      //   background: getLightenColor(colors.primary, 2),
      // },
      // 'c-results-filters__toggle': {
      //   customCSS: `
      //     .c-results-filters__toggle {
      //       color: ${getDarkenColor(colors.primary, 0.17)};
      //       box-shadow: 1px 1px 0 0 ${getLightenColor(colors.primary, 2)};
      //     }
      //     .c-results-filters__toggle:hover,
      //     .c-results-filters__toggle:focus,
      //     .c-results-filters__toggle .state-active {
      //       background-color: ${colors.secondary};
      //       box-shadow: 1px 1px 0 0 ${colors.secondary};
      //     }
      //     .c-results-filters__toggle.state-active {
      //       box-shadow:  1px 1px 0 0 ${getDarkenColor(getLightenColor(colors.secondary, 0.5), 0.05)};
      //     }
      //   `
      // },
      // 'c-results-filters__head': {
      //   color: colors.primary,
      //   customCSS: `
      //     .c-results-filters__head small .lt-ie9 {
      //       color: ${getLightenColor(colors.primary, 0.15)};
      //     }
      //     .c-results-filters__head small {
      //       color: ${hexToRgbA(colors.primary,0.65)};
      //     }
      //   `
      // },
      // 'c-results-filters__list': {
      //   background: getLightenColor(colors.primary, 2.3)
      // },
      // 'c-results-filters__single-block': {
      //   background: getLightenColor(colors.primary, 2.3)
      // },
      // 'c-results-filters__cont': {
      //   background: getLightenColor(colors.primary, 2)
      // },
      // 'c-results-panel__display-option': {
      //   customCSS: `
      //     .c-results-panel__display-option {
      //       background: ${colors.secondary};
      //     }
      //     .c-results-panel__display-option:hover,
      //     .c-results-panel__display-option:active,
      //     .c-results-panel__display-option:focus,
      //     .c-results-panel__display-option.state-active {
      //       background-color: ${getDarkenColor(colors.secondary, 0.05)};
      //     }
      //   `
      // },
      // 'c-results-panel__display': {
      //   background: colors.secondary
      // },
      // 'search-results__filters': {
      //   borderTopColor: getLightenColor(colors.primary, 2.3)
      // },
      // 'search-results__tools': {
      //   customCSS: `
      //     .search-results__tools:before {
      //       display: none;
      //     }
      //   `
      // },
      // 'search-results__panel': {
      //   background: hexToRgbA(colors.secondary, 0.1),
      // },
      // 'c-results-filters__footer__select': {
      //   boxShadow: 'none',
      // },
    },
    type1: {
      "search-results": {
        paddingTop: 0,
        customCSS: `
          .search-results__panel--full {
            width: 100%;
            background: ${getDarkenColor(colors.light, 0.04)}!important;
          }
          .state-filters-expanded .expanded-filter-hidden {
            display: none!important;
          }
          .search-display-tools > .panel__tool {
            padding-right: 10px;
          }
          .search-results .row {
            max-width: 100%;
          }
          .c-results-filters {
            max-width: 400px;
            transition: all .3s linear;
            box-shadow: none;
            border: none;
            background: ${colors.light};
          }
          .search-results__filters ul {
            margin: 0;
          }
          .state-filters-expanded .c-results-filters {
            box-shadow: 0px 4px 10px ${hexToRgbA(colors.dark, 0.09)};
            top: 0;
            right: 0;
            height: auto;
            margin-bottom: 20px;
          }
          .state-filters-expanded .c-results-filters form {
            width: 100%;
            height: calc(100% - 40px);
            margin-top: 40px;
            padding: inherit;
            position: relative;
            z-index: 999;
          }
          .c-results-filters__toggle i {
            color: ${colors.primary};
            font-size: 16px;
            margin: 0 4px;
          }
          .c-results-filters__toggle:hover i,
          .c-results-filters__toggle:focus i,
          .c-results-filters__toggle .state-active i {
            color: ${getDarkenColor(colors.primary, 0.5)};
          }
          .c-results-filters__toggle-hide i {
            font-size: 13px;
            color: #CACACA;
            transition: .3s ease-in;
          }
          .search-results select {
            color: ${colors.primary};
          }
          .panel__tools select {
            background: transparent!important;
            padding-left: 0;
            padding-right: 30px;
          }
          .search-results .c-results-filters__toggle {
            box-shadow: 0px 2px 2px ${hexToRgbA(colors.dark, 0.06)};
          }
          .search-results select,
          .search-results button,
          .search-results .c-results-filters form,
          .state-filters-expanded .search-results .c-results-filters__toggle {
            box-shadow: none;
          }
          .search-results .c-results-filters__toggle:hover,
          .search-results .c-results-filters__toggle:focus {
            background-color: ${colors.light};
          }
          .search-results form {
            margin-top: 40px;
          }
          .search-results__tools:before {
            background: ${colors.light};
          }
          .state-header-hidden .c-results-filters {
            top: 0!important;
            height: auto;
          }
          .state-filters-expanded .c-results-filters {
            background: ${colors.light}!important;
          }
          .search-display-tools .select {
            margin-right: 40px;
          }
          .c-results-panel__display-title {
            color: ${colors.primary};
          }
          @media screen and (min-width: 40em) {
            .c-results-panel .panel__tools {
              display: flex;
            }
          }
          @media screen and (max-width: 64em) {
            .c-results-filters {
              max-width: 100%;
            }
            .c-results-filters .search-display-tools {
              display: block;
              float: left;
            }
            .c-results-panel {
              padding-right: 0 !important;
              padding-left: 0 !important;
            }
            .c-results-panel .panel__tools {
              display: none;
            }
            .c-results-filters__toggle {
              margin: 0.5rem;
            }
            .state-filters-expanded .panel__tools.search-display-tools {
              max-width: initial;
            }
            .c-results-panel__badges .badge--closable {
              max-width: 250px!important;
            }
          }
          @media screen and (max-width: 24em) {
            .panel__tools.search-display-tools .panel__tool {
              max-width: 210px;
            }
          }
          @media screen and (max-width: 64em) {
            .panel__tools .button-dropdown__trigger:after {
              display: none;
            }
            .c-results-filters__toggle {
              margin: 0!important;
            }
            .c-results__dropdown-wrapper {
              display: none;
            }
          }
          @media screen and (min-width: 64em) {
            .c-results-filters {
              position: relative;
              display: flex;
              align-items: center;
              padding: 9px 30px;
            }
            .state-filters-expanded .c-results-filters {
              top: 0;
              right: -15px;
              height: calc(100vh - 88px);
              position: absolute;
              display: block;
              align-items: normal;
            }
            .state-filters-expanded .search-results__tools-inner {
              width: calc(100% - 400px);
            }
            .state-filters-expanded .search-results__panel {
              margin-right: 0 !important;
            }
            .state-filters-expanded .search-results__filters {
              right: -415px;
            }
            .state-header-hidden.state-filters-expanded .c-results-filters{
              height: 100vh;
            }
            .state-filters-expanded .c-results-filters form {
              padding-left: 30px;
              padding-right: 30px;
            }
            .search-results__panel {
              margin-right: auto;
            }
            .state-filters-expanded .search-results__filters {
              width: auto!important;
              z-index: 9999;
            }
            .c-results-filters__toggle {
              max-width: 100%;
            }
            .c-results-filters__toggle .c-results-filters__toggle-show .icon {
              font-size: 21px;
              margin: 0 5px;
            }
            .search-results__tools-inner {
              display: flex;
              justify-content: space-between;
              margin-top: 10px;
            }
            .state-header-hidden .search-results__tools-inner {
              margin-top: 0;
            }
            .state-filters-expanded .search-results__filters {
              padding: 10px 20px!important;
              max-width: 400px!important;
            }
            .panel__tools.search-display-tools {
              padding: 0.5rem 0.5rem 0.5rem 0.83333rem;
            }
            .c-results-panel__title .badge__content {
              max-height: 4.5em;
            }
          }
        `
      },
      "c-results-panel__display": {
        background: getDarkenColor(colors.light, 0.04),
        marginTop: "9px"
      },
      "c-results-filters__toggle": {
        color: colors.primary,
        display: "flex",
        padding: "5px  5px 5px 15px",
        borderRadius: "6px"
      },
      "search-settings__text": {
        display: "block",
        whiteSpace: "nowrap",
        marginRight: "44px",
        fontSize: "16px"
      },
      "search-results__panel-search-tool": {
        padding: 0,
        background: getDarkenColor(colors.light, 0.04),
        flexWrap: "wrap-reverse",
        display: "flex",
        flexDirection: "row-reverse",
        justifyContent: "flex-end",
        paddingLeft: "0.83333rem",
        paddingRight: "30px",
        width: "100%",
        marginRight: "18px"
      },
      "search-results__panel": {
        padding: 0,
        background: "transparent"
      },
      "c-results-panel": {
        background: colors.light
      },
      "c-results-panel__display-option": {
        customCSS: `
          .c-results-panel__display-option {
            background: ${getLightenColor(colors.primary, 0.1)};
          }
          .c-results-panel__display-option:hover,
          .c-results-panel__display-option:active,
          .c-results-panel__display-option:focus,
          .c-results-panel__display-option.state-active {
            background-color: ${colors.primary};
          }
          .c-results-panel__display-option i:before {
            color: ${colors.light};
          }
        `
      },
      "search-results__tools": {
        background: colors.light,
        customCSS: `
          .search-results__tools:before {
            display: none;
          }
        `
      },
      "search-results__filters": {
        background: getDarkenColor(colors.light, 0.04),
        width: "auto"
      },
      "search-results__tools__row": {
        // background: getLightenColor(getLightenColor(colors.secondary, 0.9), 0.3),
        padding: 0,
        transition: "0.3s all",
        background: colors.light
      },
      "c-results-filters__head": {
        paddingLeft: 0,
        color: colors.primary,
        customCSS: `
          .c-results-filters__head small .lt-ie9 {
            color: ${getLightenColor(colors.primary, 0.15)};
          }
          .c-results-filters__head small {
            color: ${hexToRgbA(colors.primary, 0.65)};
          }
        `
      },
      "c-results-filters__list": {
        margin: 0,
        display: "flex",
        flexDirection: "column",
        background: colors.light
      },
      "c-results-filters__filter": {
        padding: "2px 0"
      },
      "c-results-filters__footer": {
        padding: 0,
        margin: "10px 0 30px"
      },
      "c-results__select": {
        backgroundSize: "inherit",
        textDecoration: "none",
        fontWeight: "bold"
      },
      "c-results-filters__cont": {
        // boxShadow:' 0px 3px 5px rgba(0, 0, 0, 0.05)',
        overflow: "auto",
        background: colors.light
      },
      "c-results-filters__single-block": {
        padding: 0,
        margin: 0,
        background: colors.light
      },
      "c-results-filters__single-block__row": {
        margin: 0
      },
      "c-results-filters__accordian": {
        maxHeight: "none"
      },
      "c-results-panel": {
        background: colors.light,
        display: "flex",
        justifyContent: "flex-end",
        flexDirection: "row-reverse"
      },
      "c-results-panel-sets__title": {
        alignSelf: "center"
      },
      "c-results-panel__title": {
        color: colors.dark,
        fontSize: "1em",
        opacity: 0.7,
        padding: "0.5rem 0.5rem 0.5rem 0.83333rem",
        alignItems: "center",
        display: "flex",
        marginRight: "auto",
        flexWrap: "wrap",
        customCSS: `
          .c-results-panel__title div > span > span {
            font-weight: bold;
            color: ${colors.dark};
          }
          .c-results-panel__title > span {
            margin-right: 4px;
          }
          .c-results-panel__title .c-results-panel__badges .badge {
            color: ${colors.dark};
          }
          .c-results-panel__title strong {
            color: ${colors.secondary};
            margin: 0 3px;
          }
          @media screen and (max-width: 64em) {
            .c-results-panel__title {
              padding: 1.2rem 0.5rem 0 !important;
            }
          }
        `
      },
      "c-results-filters__text": {
        textTransform: "uppercase",
        color: colors.primary,
        fontWeight: "bold"
      },
      "c-results__search-display-tools": {
        zIndex: 9999,
        margin: "auto 0",
        flexDirection: "row-reverse"
        // paddingLeft: '0.83333rem'
      },
      "c-results-filters__filter--all": {
        order: -1,
        display: "flex",
        justifyContent: "flex-start",
        color: "#C4C4C4",
        marginBottom: "20px",
        padding: "10px 0 15px",
        textTransform: "capitalize",
        borderBottom: "1px solid " + hexToRgbA("#C4C4C4", 0.3),
        customCSS: `
          .c-results-filters__filter--all .c-checkbox-toggle {
            justify-content: flex-end;
          }
        `
      },
      "c-results-filters__footer__inner": {
        position: "relative",
        customCSS: `
        .c-results-filters__footer__inner:before {
          content: '\\EA44';
          position: absolute;
          top: 5px;
          left: 0;
          font-size: 12px;
          color: ${colors.secondary};
          font-family: moon-iconfont !important;
        }`
      },
      "c-results-filters__footer__select": {
        backgroundImage: "none!important"
      },
      "search-results__listings-search": {
        customCSS: `
          @media screen and (min-width: 64em) {
            .state-header-hidden .search-results .search-results__listings {
              margin-top: 0!important;
            }
            .search-results .search-results__listings {
              margin-top: 100px!important;
            }
          }
        `
      },
      "search-results__listings": {
        marginTop: "30px",
        float: "none",
        customCSS: `
          [data-article-style=details] .c-article {
            padding-top: 0!important;
            border-top: none!important;
          }
          [data-article-style=details] .c-article__content .hexagon {
            float: left;
            position: relative!important;
            top: -4px!important;
            left: -5px!important;
          }
          [data-article-style=details] .c-article__title {
            padding-top: 0!important;
          }
          [data-article-style=details] .c-article__content-wrap {
            padding-bottom: 20px;
          }
          [data-article-style=grid] .c-article__title {
            margin-bottom: 10px!important;
            max-height: 80px;
            height: 80px;
            display: block!important;
          }
        `
      }
    }
  }

  return styles[type]
}



// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/cResults.js